import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addFriend } from "../../functions/user";

export default function AddFriendSmallCard({ user: suggestion, onRemove }) {
  const [requestSent, setRequestSent] = useState(false);
  const { user } = useSelector((state) => ({ ...state }));

  const handleAddFriend = async () => {
    const res = await addFriend(suggestion._id, user.token);
    if (res === "ok") {
      setRequestSent(true);
    }
  };

  const handleRemove = () => {
    if (onRemove) {
      onRemove(suggestion._id);
    }
  };

  const fullName = `${suggestion.first_name} ${suggestion.last_name}`;

  return (
    <div className="addfriendCard">
      <div className="addfriend_imgsmall">
        <Link to={`/profile/${suggestion.username}`}>
          <img src={suggestion.picture} alt="" />
        </Link>
        <div className="addfriend_infos">
          <Link
            to={`/profile/${suggestion.username}`}
            className="addfriend_name"
          >
            {fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName}
          </Link>
          {suggestion.mutualFriendsCount > 0 && (
            <div className="mutual_friends_count">
              {suggestion.mutualFriendsCount} mutual friend
              {suggestion.mutualFriendsCount > 1 ? "s" : ""}
            </div>
          )}
          {requestSent ? (
            <div className="gray_btn" style={{ fontSize: "12px", padding: "5px 10px" }}>
              Request Sent
            </div>
          ) : (
            <div className="light_blue_btn" onClick={handleAddFriend}>
              <img
                src="../../../icons/addFriend.png"
                alt=""
                className="filter_blue"
              />
              Add Friend
            </div>
          )}
          <div
            className="remove_suggestion"
            onClick={handleRemove}
            style={{
              fontSize: "12px",
              color: "#65676b",
              cursor: "pointer",
              marginTop: "5px",
            }}
          >
            Remove
          </div>
        </div>
      </div>
    </div>
  );
}
